export const data = [
  {
    name: "F-16 Fighting Falcon",
    img: "https://www.lockheedmartin.com/content/dam/lockheed-martin/aero/photo/f16/F-21HR-Multirole-1920.jpg.pc-adaptive.480.high.jpg",
    statistics: [
      "Manufacturer: Lockheed Martin",
      "Max Speed:	1.5 Mach",
      "Range:	2,425 miles",
      "Made In: US",
    ],
  },
  {
    name: "F-22 Raptor",
    img: "http://graphics.wsj.com/how-the-worlds-best-fighter-jets-measure-up/img/f22-raptor.jpg",
    statistics: [
      "Manufacturer: Lockheed Martin",
      "Max Speed:	1.7 Mach",
      "Range:	2,002 miles",
      "Made In: US",
    ],
  },
  {
    name: "F-35 Lightning II",
    img: "http://graphics.wsj.com/how-the-worlds-best-fighter-jets-measure-up/img/f35.jpg",
    statistics: [
      "Manufacturer: Lockheed Martin",
      "Max Speed:	1.6 Mach",
      "Range:	1,381 miles",
      "Made In: US",
    ],
  },
  {
    name: "Eurofighter Typhoon",
    img: "http://graphics.wsj.com/how-the-worlds-best-fighter-jets-measure-up/img/eurofighter.jpg",
    statistics: [
      "Manufacturer: Eurofighter GmbH",
      "Max Speed:	2.0 Mach",
      "Range:	1,841 miles",
      "Made In: Europe",
    ],
  },
  {
    name: "Dassault Rafale",
    img: "http://graphics.wsj.com/how-the-worlds-best-fighter-jets-measure-up/img/rafale.jpg",
    statistics: [
      "Manufacturer: Dassault",
      "Max Speed:	1.8 Mach",
      "Range:	1,941 miles",
      "Made In: France",
    ],
  },
  {
    name: "Sukhoi T-50 ",
    img: "http://graphics.wsj.com/how-the-worlds-best-fighter-jets-measure-up/img/t50.jpg",
    statistics: [
      "Manufacturer: Sukhoi",
      "Max Speed:	2.0 Mach",
      "Range:	2,474 miles",
      "Made In: Russia",
    ],
  },
  {
    name: "F-15 Eagle ",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/F-15C_Florida_%2817149377921%29.jpg/1200px-F-15C_Florida_%2817149377921%29.jpg",
    statistics: [
      "Manufacturer: Boeing",
      "Max Speed:	2.0 Mach",
      "Range:	2,400 miles",
      "Made In: US",
    ],
  },
  {
    name: "F/A-18 Hornet ",
    img: "https://www.operationmilitarykids.org/wp-content/uploads/2021/11/the-f18-top-speed-is-mach-1.8-or-1190-mph.png",
    statistics: [
      "Manufacturer: Boeing",
      "Max Speed:	1.8 Mach",
      "Range:	1,275 miles",
      "Made In: US",
    ],
  },
  {
    name: "Su-27 Flanker",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Sukhoi_Su-27SKM_at_MAKS-2005_airshow.jpg/1024px-Sukhoi_Su-27SKM_at_MAKS-2005_airshow.jpg",
    statistics: [
      "Manufacturer: Sukhoi",
      "Max Speed:	2.0+ Mach",
      "Range:	1,910  miles",
      "Made In: Russia",
    ],
  },
  {
    name: "Su-35 Flanker-E",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Russian_Air_Force%2C_RF-81719%2C_Sukhoi_Su-35S_%2849581740157%29.jpg/1024px-Russian_Air_Force%2C_RF-81719%2C_Sukhoi_Su-35S_%2849581740157%29.jpg",
    statistics: [
      "Manufacturer: Sukhoi",
      "Max Speed:	2.2 Mach",
      "Range:	2,200  miles",
      "Made In: Russia",
    ],
  },
  {
    name: "Su-34 Fullback",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/MAKS2015part1-10_%28cropped%29.jpg/300px-MAKS2015part1-10_%28cropped%29.jpg",
    statistics: [
      "Manufacturer: Sukhoi",
      "Max Speed:	1.2 Mach",
      "Range:	2,200  miles",
      "Made In: Russia",
    ],
  },
  {
    name: "JAS 39 Gripen",
    img: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Saab_JAS_39_Gripen_at_Kaivopuisto_Air_Show%2C_June_2017_%28altered%29_copy.jpg/300px-Saab_JAS_39_Gripen_at_Kaivopuisto_Air_Show%2C_June_2017_%28altered%29_copy.jpg",
    statistics: [
      "Manufacturer: Saab",
      "Max Speed:	1.2 Mach",
      "Range:	1,700  miles",
      "Made In: Sweden",
    ],
  },
];
